import { AHIcon, Box } from "arkh";
import React from "react";
import { WebModal } from "../../../../../TopLevelNavigators/UserLoggedIn/WebModal";
import { Modal } from "react-native";
import { LazyQueryNetworkBoundrary } from "../../../../../components/mobile/QueryNetworkBoundrary";
import { WorkspaceFilesScreenComponent } from "../../../WorkspaceFiles/WorkspaceFiles";
import { PendingFile } from "../../../../Files/FileUploadArea";
import { WebModalHeader } from "./WebModalHeader";

export function WorkspaceTodoLinkFileModal(props: {
  showModal: boolean;
  setShowModal: (show: boolean) => void;
  workspaceId: string;
  todoId: string;
  modalKey: string;
  initialFiles: PendingFile[];
  addFiles: (todoId: string, fileIds: string[]) => void;
}) {
  return (
    <Modal
      visible={props.showModal}
      transparent
      presentationStyle="overFullScreen"
      animationType="fade"
      style={{ flex: 1 }}
    >
      <WebModal>
        <Box style={{ flex: 1 }} color="surface-background-light">
          <WebModalHeader
            close={
              <WebModalHeader.CloseButton
                onPress={() => props.setShowModal(false)}
              />
            }
          />
          <LazyQueryNetworkBoundrary>
            {(fetchKey) => (
              <WorkspaceFilesScreenComponent
                workspaceId={props.workspaceId}
                fetchKey={fetchKey}
                key={props.modalKey}
                initialFiles={props.initialFiles}
                onFileItemPress={(file) => {
                  props.addFiles(props.todoId, [file.id]);
                  props.setShowModal(false);
                }}
                itemActionComponent={<AHIcon type="add" color="primary" />}
                onUploadedFiles={(fileIds) => {
                  props.addFiles(props.todoId, fileIds);
                  props.setShowModal(false);
                }}
                write
              />
            )}
          </LazyQueryNetworkBoundrary>
        </Box>
      </WebModal>
    </Modal>
  );
}
